import { Popup, PopupProps } from 'lib/classes/popup';
import { getLocaleString } from 'lib/localization/vendor';
import { parseURLs } from 'lib/utilities/misc';

import 'styles/css/LinkedResourcesPopup.scss';

const LinkedResourcesPopup = new Popup({
	title: () => getLocaleString('linkedresources'),
	style: {maxWidth: 550, minWidth: 400},
	render: function() {
		const mapConfig:any = this.get('opus-config');
		const rows:any[] = [];
		
		const linkedResources:any[] = parseURLs(mapConfig.linkedResources || '');
		
		linkedResources.forEach(({label, url}) => {
			rows.push(
				<div className='linked-resource' key={rows.length}>
					<a href={url} target='_blank'>
						{label} 
					</a>
					<div className='gray-label small'>
						<i>{url}</i>
					</div>
				</div>
			)
		});
		
		return (
			<>
				<div>
					{rows.length} {getLocaleString('linked-rsrs')}
				</div>
				
				<hr />
				
				{rows}
			</>
		);
	}
});

export default LinkedResourcesPopup;